<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M1.51,802.5H4.5v-9H3v2l-1.5,1V802.5z M2.5,782.5l1,2h5v2l-4,1v3l-2,1l-1,3h-2l-1-3l-2-1v-3l-4-1v-2h5l1-2H2.5z M0.5,784.5
	l-2,2l2,2l2-2L0.5,784.5z M-0.51,802.5H-3.5v-9H-2v2l1.49,1V802.5z M-7.5,788.5l2,0.5v6.5l-2-1V788.5z M8.5,788.5l-2,0.5v6.5l2-1
	V788.5z"/>
</svg>

</template>